import { toast } from 'react-toastify';
import appApi from '../../../../../../../../api/app-api';
import { HttpStatusCode } from 'axios';
import globalCourseStore from '../../../../../../../../stores/global-course-store';
import dateUtils from '../../../../../../../../utils/date-format';

export const updateAssignmentDetailsOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  assignmentId: number | undefined,
  assignmentName: string | null | undefined,
  dueDate: Date | null | undefined,
  setUpdateAssignmentDetailsLoading: (loading: boolean) => any,
) => {
  try {
    if (!programId || !courseId || !assignmentId) {
      toast.warn(
        'לא ניתן לאתר את המזהה של התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים...',
      );
      return;
    }

    setUpdateAssignmentDetailsLoading(true);
    const dueDatePayload =
      dueDate != null ? dateUtils.formattedDateWithNoTime(dueDate) : null;
    const res = await appApi.updateAssignment(
      programId,
      courseId,
      assignmentId,
      assignmentName ?? '',
      dueDatePayload,
    );

    setUpdateAssignmentDetailsLoading(false);

    if (res.status === HttpStatusCode.Ok) {
      globalCourseStore.updateCourseDetails(
        courseId,
        res.data.body.metadata,
        res.data.body.details,
      );
    }
  } catch (e) {
    setUpdateAssignmentDetailsLoading(false);
    console.error(
      `updateAssignmentDetailsOperation is failed with the programId: ${programId}, courseId: ${courseId}, assignmentId: ${assignmentId} with the error: ${e}`,
    );
  }
};
